<div class="call-transcript-dialog flex flex-col">
  @if (view$ | async; as view) {
    <header class="flex items-center gap-3 px-6 pb-3 pt-6">
      <mat-icon class="text-primary-500">{{ view.display.icon }}</mat-icon>
      <div class="flex flex-col">
        <span class="title text-accent-900 text-lg font-semibold">{{
          view.display.label
        }}</span>
        <span class="text-accent-300 text-sm">
          {{ callerIdentity }}
          @if (formattedCreatedAt) {
            <span>&nbsp;&bull;&nbsp;{{ formattedCreatedAt }}</span>
          }
        </span>
      </div>
    </header>

    @if (summary) {
      <section
        class="summary bg-accent-50 mx-6 mb-3 flex flex-col gap-1 rounded-lg p-3"
      >
        <span class="text-accent-300 text-xs font-semibold">Summary</span>
        <span class="text-accent-900 text-sm">{{ summary }}</span>
      </section>
    }

    <section class="transcript-body px-6 pb-2">
      @if (view.turns) {
        <div class="turns flex flex-col gap-3">
          @for (turn of view.turns; track $index) {
            <div
              class="turn flex"
              [class.turn--agent]="turn.isAgent"
              [class.turn--caller]="!turn.isAgent"
            >
              <div
                class="turn__bubble flex flex-col gap-1 rounded-lg p-3"
                [ngClass]="
                  turn.isAgent
                    ? 'bg-accent-50 text-accent-900'
                    : 'bg-primary-500 text-white'
                "
              >
                <span class="turn__speaker text-xs font-semibold">{{
                  turn.speakerLabel
                }}</span>
                <span class="turn__text text-sm">{{ turn.text }}</span>
              </div>
            </div>
          }
        </div>
      } @else {
        <pre class="raw-transcript text-accent-900 text-sm">{{
          rawTranscript
        }}</pre>
      }
    </section>
  }

  <footer class="flex items-center justify-end gap-2 px-6 py-4">
    <button mat-stroked-button mat-dialog-close>Close</button>
  </footer>
</div>
